export default __webpack_public_path__ + "static/media/remmittance.0fbe89c0.png";